import { Row, Col, Divider } from 'antd';
import formatCurrencyVND from 'utils/formatCurrencyVND';

interface IProps {
  product?: any;
}
export default function ProductInfo(props: IProps): JSX.Element {
  const { product } = props;

  return (
    <>
      {/* <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-4">
        <Col className="" span={24}>
          <Row gutter={{ xs: 8, sm: 24, md: 24, lg: 32 }} className="mb-4">
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">Mã code</div>
              <div className="text-sm">{product?.product_code || '-'}</div>
            </Col>
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">BST</div>
              <div className="text-sm">{product?.bst_text || '-'}</div>
            </Col>
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">PL Style</div>
              <div className="text-sm">{product?.bst || '-'}</div>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 24, md: 24, lg: 32 }} className="mb-4">
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">Basic</div>
              <div className="text-sm">{product?.basic_product || '-'}</div>
            </Col>
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">Bộ</div>
              <div className="text-sm">{product?.zma_bo_text || '-'}</div>
            </Col>
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">
                Size ổ hột
              </div>
              <div className="text-sm">{product?.ohot_kc_text || '-'}</div>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 24, md: 24, lg: 32 }} className="mb-4">
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">
                Ngành hàng
              </div>
              <div className="text-sm">{product?.prod_grp2_name || '-'}</div>
            </Col>
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">Cặp</div>
              <div className="text-sm">{product?.zma_ts_cap_text || '-'}</div>
            </Col>
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">
                Phân nhóm
              </div>
              <div className="text-sm">{product?.bst || '-'}</div>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 24, md: 24, lg: 32 }} className="mb-4">
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">
                Dòng hàng SAP
              </div>
              <div className="text-sm">{product?.line_sap || '-'}</div>
            </Col>
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">Mã code</div>
              <div className="text-sm">{product?.product_code || '-'}</div>
            </Col>
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">PLHH</div>
              <div className="text-sm">{product?.bst || '-'}</div>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 24, md: 24, lg: 32 }} className="mb-4">
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">Xman</div>
              <div className="text-sm">{product?.xman || '-'}</div>
            </Col>
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">Nhóm đá</div>
              <div className="text-sm">{product?.product_code || '-'}</div>
            </Col>
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">
                Is_DMHHKN
              </div>
              <div className="text-sm">{product?.bst || '-'}</div>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 24, md: 24, lg: 32 }} className="mb-4">
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">
                Chủng loại
              </div>
              <div className="text-sm">{product?.chungloai_text || '-'}</div>
            </Col>
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">
                Material Type
              </div>
              <div className="text-sm">{product?.product_type_name || '-'}</div>
            </Col>
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">PLHH</div>
              <div className="text-sm">{product?.bst || '-'}</div>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 24, md: 24, lg: 32 }} className="mb-4">
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">
                Giới tính
              </div>
              <div className="text-sm">{product?.gioitinh_text || '-'}</div>
            </Col>
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">
                Tuổi vàng
              </div>
              <div className="text-sm">{product?.purity_of_gold || '-'}</div>
            </Col>
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">
                Material (Mẫu đại diện)
              </div>
              <div className="text-sm">{product?.mau_dai_dien || '-'}</div>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 24, md: 24, lg: 32 }} className="mb-4">
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">
                Giá vốn tồn tham khảo
              </div>
              <div className="text-sm">
                {formatCurrencyVND(product?.cost_price || 0)}
              </div>
            </Col>
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">Màu sắc</div>
              <div className="text-sm">{product?.mausac_text || '-'}</div>
            </Col>
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">
                Material Group
              </div>
              <div className="text-sm">{product?.prod_grp_name || '-'}</div>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 24, md: 24, lg: 32 }} className="mb-4">
            <Col className="" span={16}>
              <div className="text-base font-bold text-primary-0">
                Phân khúc giá
              </div>
              <div className="text-sm">{product?.phankhuc_kh_text || '-'}</div>
            </Col>
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">PL ni</div>
              <div className="text-sm">{product?.item_size || '-'}</div>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 24, md: 24, lg: 32 }} className="mb-4">
            <Col className="" span={16}>
              <div className="text-base font-bold text-primary-0">
                Loại đá phụ
              </div>
              <div className="text-sm">{product?.daphu_text || '-'}</div>
            </Col>

            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">
                Đánh giá TQ
              </div>
              <div className="text-sm">{product?.bst || '-'}</div>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 24, md: 24, lg: 32 }} className="mb-4">
            <Col className="" span={16}>
              <div className="text-base font-bold text-primary-0">Nhóm đá</div>
              <div className="text-sm">{product?.bst || '-'}</div>
            </Col>
            <Col className="" span={8}>
              <div className="text-base font-bold text-primary-0">
                PL Tình trạng
              </div>
              <div className="text-sm">{product?.bst || '-'}</div>
            </Col>
          </Row>
        </Col>
      </Row> */}

      <Row
        className="mt-6 custom-title"
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
      >
        <Col span={4}>
          <Row>
            <Col span={24}>
              <strong>Aging Danh mục</strong>
            </Col>
            <Col span={24}>{product?.aging || '-'}</Col>
            <Col span={24}>
              <strong>Aging cửa hàng</strong>
            </Col>
            <Col span={24}>{product?.aging_shop || '-'}</Col>
            <Col span={24}>
              <strong>Màu sắc</strong>
            </Col>
            <Col span={24}>{product?.mausac_text || '-'}</Col>
          </Row>
        </Col>
        <Col span={5}>
          <Row>
            <Col span={24}>
              <strong>Mã code</strong>
            </Col>
            <Col span={24}>{product?.pro_code || '-'}</Col>
            <Col span={24}>
              <strong>Basic</strong>
            </Col>
            <Col span={24}>{product?.basic_product || '-'}</Col>
            <Col span={24}>
              <strong>Ngành hàng</strong>
            </Col>
            <Col span={24}>{product?.prod_grp2_name || '-'}</Col>
            <Col span={24}>
              <strong>Dòng hàng SAP</strong>
            </Col>
            <Col span={24}>{product?.line_sap_text || '-'}</Col>
            <Col span={24}>
              <strong>Xman</strong>
            </Col>
            <Col span={24}>{product?.line_xman_text || '-'}</Col>
            <Col span={24}>
              <strong>Giá bán</strong>
            </Col>
            <Col span={24}>{formatCurrencyVND(product?.price) || '-'}</Col>
            <Col span={24}>
              <strong>Giá vốn tồn tham khảo</strong>
            </Col>
            <Col span={24}>{formatCurrencyVND(product?.cost_price)}</Col>
          </Row>
        </Col>
        <Col span={5}>
          <Row>
            <Col span={24}>
              <strong>Phân khúc giá</strong>
            </Col>
            <Col span={24}>{product?.phankhuc_gia || '-'}</Col>
            <Col span={24}>
              <strong>BST</strong>
            </Col>
            <Col span={24}>{product?.bst_text || '-'}</Col>
            <Col span={24}>
              <strong>Bộ</strong>
            </Col>
            <Col span={24}>{product?.zma_bo_text || '-'}</Col>
            <Col span={24}>
              <strong>Cặp</strong>
            </Col>
            <Col span={24}>{product?.zma_ts_cap_text || '-'}</Col>
            <Col span={24}>
              <strong>Mã code</strong>
            </Col>
            <Col span={24}>{product?.pro_code || '-'}</Col>
            <Col span={24}>
              <strong>Nhóm đá</strong>
            </Col>
            <Col span={24}>{product?.nhom_da || '-'}</Col>
            <Col span={24}>
              <strong>Loại đá phụ</strong>
            </Col>
            <Col span={24}>{product?.daphu || '-'}</Col>
          </Row>
        </Col>
        <Col span={5}>
          <Col span={24}>
            <strong>Chủng loại</strong>
          </Col>
          <Col span={24}>{product?.chungloai_text || '-'}</Col>
          <Col span={24}>
            <strong>Giới tính</strong>
          </Col>
          <Col span={24}>{product?.gioitinh_text || '-'}</Col>
          <Col span={24}>
            <strong>PL Style</strong>
          </Col>
          <Col span={24}>-</Col>
          <Col span={24}>
            <strong>Size ổ hột</strong>
          </Col>
          <Col span={24}>{product?.ohot_kc_text || '-'}</Col>
          <Col span={24}>
            <strong>Material Type</strong>
          </Col>
          <Col span={24}>{product?.material_type || '-'}</Col>
          <Col span={24}>
            <strong>Tuổi vàng</strong>
          </Col>
          <Col span={24}>{product?.purity_of_gold || '-'}</Col>
          <Col span={24}>
            <strong>PLHH</strong>
          </Col>
          <Col span={24}>{product?.plhh || '-'}</Col>
        </Col>
        <Col span={5}>
          <Row>
            <Col span={24}>
              <strong>Phân nhóm</strong>
            </Col>
            <Col span={24}>{product?.phan_nhom || '-'}</Col>
            <Col span={24}>
              <strong>Is_DMHHKN</strong>
            </Col>
            <Col span={24}>{product?.is_dmhhkn || '-'}</Col>
            <Col span={24}>
              <strong>Material (Mẫu đại diện)</strong>
            </Col>
            <Col span={24}>
              {product?.mau_dai_dien === true ? 'Có' : 'Không'}
            </Col>
            <Col span={24}>
              <strong>Material Group</strong>
            </Col>
            <Col span={24}>{product?.material_group || '-'}</Col>
            <Col span={24}>
              <strong>PL ni</strong>
            </Col>
            <Col span={24}>{product?.item_size || '-'}</Col>
            {/* <Col span={24}>
                  <strong>Đánh giá TQ</strong>
                </Col>
                <Col span={24}>{product?.kldg_3tc || '-'}</Col> */}
            <Col span={24}>
              <strong>PL Tình trạng</strong>
            </Col>
            <Col span={24}>{product?.cnsx_text || '-'}</Col>
          </Row>
        </Col>
      </Row>
      <Divider />
      <Row
        className="mt-6 custom-title"
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
      >
        <Col span={4}>
          <Row>
            <Col span={24}>
              <strong>Đánh giá theo KV</strong>
            </Col>
            <Col span={24}>{product?.dghh_kv || '-'}</Col>
            {/* <Col span={24}>
                  <strong>Đánh giá HH theo KV</strong>
                </Col>
                <Col span={24}>{product?.dghh_kv || '-'}</Col> */}
            <Col span={24}>
              <strong>Đánh giá TQ</strong>
            </Col>
            <Col span={24}>{product?.kldg_3tc || '-'}</Col>
          </Row>
        </Col>
        <Col span={5}>
          <Row>
            <Col span={24}>
              <strong> Số tháng không phát sinh doanh thu liên tiếp</strong>
            </Col>
            <Col span={24}>
              {product?.so_thang_khong_phat_sinh_doanh_thu_lien_tiep || '-'}
            </Col>
            <Col span={24}>
              <strong>Doanh thu 6 tháng (VND)</strong>
            </Col>
            <Col span={24}>
              {formatCurrencyVND(product?.doanh_thu_6_thang_vnd) || '-'}
            </Col>
          </Row>
        </Col>
        <Col span={5}>
          <Row>
            <Col span={24}>
              <strong>Doanh số TB 6 tháng (VND)</strong>
            </Col>
            <Col span={24}>
              {formatCurrencyVND(product?.doanh_thu_tb_6_thang_vnd) || '-'}
            </Col>
            <Col span={24}>
              <strong>Doanh số TB 6 tháng (Món)</strong>
            </Col>
            <Col span={24}>{product?.doanh_so_tb_6_thang_mon || '-'}</Col>
          </Row>
        </Col>
        <Col span={5}>
          <Row>
            <Col span={24}>
              <strong> Doanh thu kỳ vọng KV</strong>
            </Col>
            <Col span={24}>
              {formatCurrencyVND(product?.doanh_thu_ky_vong_kv_vnd) || '-'}
            </Col>
            <Col span={24}>
              <strong> Doanh số kỳ vọng KV</strong>
            </Col>
            <Col span={24}>{product?.doanh_so_ky_vong_kv_mon || '-'}</Col>
          </Row>
        </Col>
        <Col span={5}>
          <Row>
            <Col span={24}>
              <strong> Doanh thu kỳ vọng TQ</strong>
            </Col>
            <Col span={24}>
              {formatCurrencyVND(product?.doanh_thu_ky_vong_tq_vnd) || '-'}
            </Col>
            <Col span={24}>
              <strong> Doanh số kỳ vọng TQ</strong>
            </Col>
            <Col span={24}>{product?.doanh_so_ky_vong_tq_mon || '-'}</Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
